export const EMAIL_REGEX = new RegExp(
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
);

// Word and Outlook autocorrect ' into a curly quote, which no mail server accepts.
export const CURLY_APOSTROPHES = /[\u2018\u2019]/g;

// Raw special characters for display/reference
export const PASSWORD_SPECIAL_CHARS = /[!@#$%^&*()\-_=+{}[\]|\\`":;'<>.,?~]/;

export const MIN_PASSWORD_LENGTH = 8;
